import { render } from "./ViewRecensement.vue?vue&type=template&id=17cd9693&ts=true"
import script from "./ViewRecensement.vue?vue&type=script&lang=ts"
export * from "./ViewRecensement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__